
import React, {useState} from 'react';
import './App.css';
import {Menu} from './Menu';
import {MainView} from './MainView';
import {Gallery} from './Gallery';
import {Download} from "./Download";
import {About} from "./About";

function App() {

  const [view, setView] = useState("main");

  const [galleryIndex, setGalleryIndex] = useState(0);


  return (
    <div>
        <Menu view={view} setView={setView}/>

      { view === "main" && <MainView setView={setView} setGalleryIndex={setGalleryIndex}/>}
      { view === "gallery" && <Gallery galleryindex={galleryIndex}/>}
      { view === "download" && <Download/>}
      { view === "about" && <About/>}

        { false && <span className={"copyright"}>© Lukas Brunner & Jonas Prohaska</span> }

    </div>
  );
};

export default App;
